module.exports = __webpack_public_path__ + "static/media/cpu.0435bd80.svg";